import { interceptor } from '@/common/utils/interceptor';
import * as Constants from '@/common/utils/constants';

export default [
  {
    path: '/error',
    component: () => import('@/pages/homepage/error')
  },
  {
    path: '/homepage/payment',
    component: () => import('@/pages/homepage/payment'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_NO);
    }
  }
];
